import { ArtistSignup } from "../../signup/types";
import { Group } from "../../user";

export const ReportQueryTypes = [
  "monthly_shows",
  "yearly_shows",
  "artists",
  "setlive_shows_scheduled_monthly",
  "setlive_shows_added_monthly",
  "setbio",
  "setfan",
  "setfan_responses_monthly",
  "setfan_profiling_monthly",
  "setfan_recent",
  "setlive_shows_scheduled_year",
  "setlive_recent",
  "setlive_upcoming",
  "setlive_scheduled",
  "setlive_added",
  "setlive_usage",
  "setlive_early_usage",
  "brand_preferences",
  "presave_summary",
  "last_updated_at",
  "integration_sync_summary",
  "integration_sync_errors_by_artist_group",
  "forward_looking_inventory",
  "artists_added_by_month",
  "set_shows_scheduled_by_month",
  "set_live_entries_by_month",
  "set_fan_entries_by_month",
] as const;
export type ReportQueryType = (typeof ReportQueryTypes)[number];

export const ReportFunctionTypes = ["user_lookup"] as const;
export type ReportFunctionType = (typeof ReportFunctionTypes)[number];

export const ReportTypes = [
  ...ReportQueryTypes,
  ...ReportFunctionTypes,
] as const;
export type ReportType = (typeof ReportTypes)[number];

export const isReportQueryType = (
  reportType: ReportType,
): reportType is ReportQueryType => {
  return ReportQueryTypes.includes(reportType as ReportQueryType);
};

export const ReportsByGroup: Record<Group, ReportType[]> = {
  admin: [...ReportTypes],
  executive: ["last_updated_at"],
  finance: [
    "artists_added_by_month",
    "set_shows_scheduled_by_month",
    "set_live_entries_by_month",
    "set_fan_entries_by_month",
    "last_updated_at",
  ],
};

export interface UserLookup {
  uid: string;
  firstName?: string;
  lastName?: string;
  email: string;
  title?: string;
  phone?: string;
  mfa?: string[];
  customClaims?: Record<string, unknown>;
  createdAt: string;
  lastLoginAt: string;

  affiliations: {
    artistGroupId?: string;
    artistName: string;
    role: string;
    admin: boolean;
    genre?: string;
    status?: ArtistSignup["status"];
    action?: ArtistSignup["action"];
    company?: string;
    companyLink?: string;
    affiliation?: string;
  }[];
}

export interface AdminReportRequest<T extends ReportType = ReportType> {
  reportType: T;
  parameters?: Record<string, unknown>;
}

export interface AdminReportResponseBase<
  T extends ReportType = ReportType,
  D = unknown,
> {
  success: boolean;
  reportType: T;
  data: D;
  rowCount: number;
  executedAt: string;
}

export const getAvailableReportTypes = (
  superAdmin: boolean,
  groups: Group[],
): ReportType[] => {
  if (superAdmin) {
    return [...ReportTypes];
  }

  // pull all reports for groups and dedupe
  const typesForGroups = groups.flatMap((group) => ReportsByGroup[group]);
  return Array.from(new Set(typesForGroups));
};
